import { render, staticRenderFns } from "./zhiTongAliDang.vue?vue&type=template&id=e86c224a&scoped=true&"
import script from "./zhiTongAliDang.vue?vue&type=script&lang=js&"
export * from "./zhiTongAliDang.vue?vue&type=script&lang=js&"
import style0 from "./zhiTongAliDang.vue?vue&type=style&index=0&id=e86c224a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e86c224a",
  null
  
)

export default component.exports